import React from 'react';
import clsx from 'clsx';

import './GradientLine.scss';

export default function GradientLine({ className }: { className?: string }) {
  return <div className={clsx('gradient-line', className)}></div>;
}
